import React, { useEffect, useState } from "react";
import { uniqueId } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from "@material-ui/core";
// icons and images
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import searchIcon from "../../../assets/image/searchIcon.svg";
// utils
import { isLoggedIn } from "../../../utils";
// custom components
import TableLoader from "../../common/TableLoader";
import { deleteTag, getAllTags, updateTag } from "../../../containers/Admin/HeatPumpDevices/actions";
import * as commonActions from '../../../containers/common/actions'
import * as actions from "../../../containers/Admin/HeatPumpDevices/actions";


export default function AssignTagsModal(props) {
  const { assignTagsToDevices, oldTags } = props?.globalModal.data || {};
  const { userType = null } = isLoggedIn();
  const dispatch = useDispatch();

  const { allTags: defaultTags = {}, allTagsLoading = false } = useSelector((state) => state.heatPumpDevices);

  const [allTags, setAllTags] = useState([]);
  const [existingTags, setExistingTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState(oldTags || []);
  const [searchInput, setSearchInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editingTag, setEditingTag] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTagsList = async () => {
    const response = await dispatch(getAllTags());
    setExistingTags(response?.info || []);
  };

  const handleHeatPumpDevices = () => {
    dispatch(actions.getallHeatPumpDevices({
      limit: 25,
      page: 1,
      sortBy: "created_at",
      orderBy: "desc",
    })).then((res) => { });
  };

  const handleSearch = ({ target: { value = "", name = "" } }) => {
    setSearchInput(value || "")

    if (!value) {
      setExistingTags([...(allTags || [])])
    } else {
      const filteredTags = allTags?.filter(tag => tag.name?.includes(value))
      setExistingTags(filteredTags)
    }
  }

  const selectTag = (tag) => {
    const isTagSelected = selectedTags.some(selectedTag => selectedTag.name === tag.name)

    if (isTagSelected) {
      setSelectedTags(prev => {
        const filteredTags = prev.filter(selectedTag => selectedTag.name !== tag.name)
        return [...filteredTags]
      });
    } else {
      setSelectedTags(prev => ([...prev, tag]));
    }
  };

  const handleCreateTag = (e) => {
    const { value } = e.target;

    if (e.key === "Enter" && value) {
      const existingTag = existingTags.find(tag => tag.name === value);
      if (existingTag) {
        selectTag(existingTag);
      } else {
        const newTag = { name: value, id: uniqueId() };
        setAllTags(prev => {
          setExistingTags(() => [newTag, ...prev]);
          return [newTag, ...prev];
        });
        const isTagSelected = selectedTags.some(selectedTag => selectedTag.name === value);

        if (!isTagSelected) {
          setSelectedTags(prev => [...prev, { name: value }]);
        }
      }

      setSearchInput(""); // clear search input after creating tag
      // setExistingTags(allTags);
      setEditingTag(null);  // clear editing after updating tag name
    }
  }

  const handleRemoveTag = (tagName) => {
    if (!tagName) return;

    setSelectedTags(prev => {
      const filteredTags = prev.filter(selectedTag => selectedTag.name !== tagName)
      return [...filteredTags]
    });
  }

  const handleCloseActionMenu = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
    setEditingTag(null)
  };

  const handleUpdateTag = async () => {
    if (!editingTag) return setEditingTag(null);

    dispatch(updateTag({ ...editingTag, tag_name: editingTag.name })).then(() => {
      const updateIndex = existingTags.findIndex(tag => tag.id === editingTag.id);
      if (updateIndex >= 0) {
        setExistingTags(prev => {
          const oldTags = [...prev];
          oldTags[updateIndex] = editingTag;
          return [...oldTags];
        });
      }

      const selectedIndex = selectedTags.findIndex(tag => tag.id === editingTag.id);
      if (selectedIndex >= 0) {
        setSelectedTags(prev => {
          const oldTags = [...prev];
          oldTags[selectedIndex] = editingTag;
          return [...oldTags];
        })
      }

    }).catch(error => {
      console.log("error", error);
    }).finally(() => {
      setEditingTag(null);
    })
  }

  const deleteModelHandler = (tagId) => {
    if (!tagId) return;

    dispatch(deleteTag(tagId)).then(() => {
      setSearchInput("")
      handleTagsList()
      setSelectedTags(prev => {
        const filteredTags = [...prev].filter(selectedTag => selectedTag.id !== tagId)
        return [...filteredTags]
      })
      handleHeatPumpDevices();
      dispatch(commonActions.closeDeleteModal())
    })
  }

  const handleDeleteTag = async (tag) => {
    dispatch(commonActions.openDeleteModal({
      confirmAction: () => deleteModelHandler(tag.id),
      title: 'DELETE TAG',
      dialogtext: 'Are you sure you want to delete this Tag?'
    }))
  }

  const onSubmit = () => {
    if (selectedTags?.length > 0) {
      setIsSubmitting(true)

      const tag_ids = selectedTags.map(tag => tag.id ? tag.id : null).filter(Boolean);
      const extra_tags = selectedTags.map(tag => !tag.id ? tag.name : null).filter(Boolean);

      const request = { tag_ids, extra_tags }
      assignTagsToDevices(request)
        .then(() => {
          props.closeModal();
          handleHeatPumpDevices();
        })
        .catch(err => err)
        .finally(() => { setIsSubmitting(false) });
    } else {
    }
  };

  useEffect(() => {
    handleTagsList();
  }, []);

  useEffect(() => {
    setAllTags(defaultTags)
  }, [defaultTags])

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex align-items-center con-space-between gap-2">
          <span className="multi-site-head">Choose or Create tags for the selected devices</span>
        </Grid>
      </DialogTitle>

      <DialogContent dividers className="heat_pump_dialog_content">
        {/* Search and create field */}
        <TextField
          className="heat_pump_dialog_content_searchbar"
          placeholder={"Search or create tags"}
          variant="filled"
          fullWidth
          name="contact_person_email"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className="srhIcon">
                <img src={searchIcon} />
              </InputAdornment>
            ),
          }}
          value={searchInput}
          onChange={handleSearch}
          onKeyPress={handleCreateTag}
        />

        {/* Selected tags */}
        <Grid item md={12} className="">
          {
            selectedTags?.map(tag => (
              <div className="tags-dev mb-1" key={tag}>
                <span className="text-break-word">{tag.name}</span>
                <span className="cus-pointer flex-shrink-0" onClick={() => handleRemoveTag(tag.name)}><CloseIcon /></span>
              </div>
            ))
          }
        </Grid>

        {/* tags listing */}
        <Grid item md={12} className="">
          {(userType === "Admin" && allTagsLoading) ? (
            <TableLoader />
          ) : existingTags && existingTags.length > 0 ? (
            <List dense className="heat_pump_dialog_content_list device-tags-modal-list">
              {existingTags.map((tag, i) => {
                const isTagSelected = selectedTags.some(selectedTag => selectedTag.name === tag.name)

                return (
                  <Card className="mb-2 mt-0 p-0" variant="outlined">
                    <CardContent className="p-0">
                      <ListItem
                        key={`${tag}-${i}`}
                        button
                        className={`tagSelected ${isTagSelected ? "listItemSelected" : ""}`}
                        onClick={() => {
                          if (editingTag?.name === tag?.name) return;
                          selectTag(tag)
                        }}
                      >
                        {
                          editingTag?.id === tag?.id
                            ? <>
                              <TextField
                                className="reNameInput"
                                placeholder={"Enter tag"}
                                variant="filled"
                                fullWidth
                                name="tag"
                                value={editingTag?.name}
                                onChange={e => {
                                  const { value } = e.target
                                  setEditingTag(prev => ({ ...prev, name: value }))
                                }}
                              // onKeyPress={handleCreateTag}
                              />
                            </>
                            : <>
                              <ListItemSecondaryAction >
                                <input
                                  type="checkbox"
                                  className="heat_pump_checkbox"
                                  edge="end"
                                  name="selectDevice"
                                  value={tag.id}
                                  checked={isTagSelected}
                                  readOnly
                                  inputProps={{ "aria-labelledby": `checkbox-list-secondary-label-${i}` }}
                                />
                                {isTagSelected && <svg className="tag-selected-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(0,168,142,1)">
                                  <path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"></path>
                                </svg>}
                              </ListItemSecondaryAction>
                              <ListItemText
                                id={`checkbox-list-secondary-label-${i}`}
                                primary={<p className="text-left text-break-word  "> {tag.name}</p>}
                              />
                            </>
                        }

                        {/* Tags actions */}
                        {
                          editingTag?.id === tag.id ?
                            <>
                              <Button
                                id={`basic-button-${i}`}
                                aria-controls={anchorEl && anchorEl.index === i ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorEl && anchorEl.index === i ? "true" : undefined}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setAnchorEl(null);
                                  setEditingTag(null)
                                }}
                                className="cancelIcon"
                              >
                                <CancelIcon />
                              </Button>

                              <Button
                                id={`basic-button-${i}`}
                                aria-controls={anchorEl && anchorEl.index === i ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorEl && anchorEl.index === i ? "true" : undefined}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleUpdateTag()
                                  setAnchorEl(null);
                                }}
                                className="tickIcon"
                              >
                                <CheckCircleIcon />
                              </Button>
                            </>
                            : <>
                              <Button
                                className="actionIcon-dot"
                                id={`basic-button-${i}`}
                                aria-controls={anchorEl && anchorEl.index === i ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorEl && anchorEl.index === i ? "true" : undefined}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setAnchorEl({ el: event.currentTarget, index: i });
                                }}
                              >
                                <MoreHorizIcon />
                              </Button>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorEl && anchorEl.index === i ? anchorEl.el : null}
                                // keepMounted
                                open={anchorEl && anchorEl.index === i}
                                onClose={handleCloseActionMenu}
                                disablePortal
                                MenuListProps={{ "aria-labelledby": `basic-button-${i}` }}
                                className="tagActionMenu"
                              >
                                <MenuItem
                                  onClick={(e) => {
                                    e?.stopPropagation();
                                    setEditingTag(tag);
                                    setAnchorEl(null);
                                  }}>
                                  <EditIcon style={{ color: 'var(--light-blue)' }} />
                                  Rename
                                </MenuItem>
                                <MenuItem
                                  onClick={(e) => {
                                    e?.stopPropagation();
                                    handleDeleteTag(tag);
                                    setAnchorEl(null);
                                  }}>
                                  <DeleteIcon style={{ color: 'var(--error-red-color)' }} />
                                  Delete
                                </MenuItem>
                              </Menu>
                            </>
                        }
                      </ListItem>
                    </CardContent>
                  </Card>
                )
              })}
            </List>
          ) : (
            <p className="text-center mt-40 no-data-modal-text">Press enter to create a new tag</p>
          )}
        </Grid>
      </DialogContent >

      {/* Action buttons */}
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${!selectedTags?.length ? "disabled" : ""}`}
            onClick={isSubmitting ? null : onSubmit}>
            {isSubmitting ? (
              <CircularProgress size={18} color="white" />
            ) : (
              "Assign"
            )}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
